module.exports = __webpack_public_path__ + "img/w27-b2.6c27d0ef.jpg";